import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  Home, 
  Search,
  CheckSquare,
  Users,
  User
} from 'lucide-react';

const BottomNavBar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    {
      path: '/dashboard',
      icon: Home,
      label: 'Home'
    },
    {
      path: '/explore',
      icon: Search,
      label: 'Explore'
    },
    {
      path: '/next',
      icon: CheckSquare,
      label: 'Next'
    },
    {
      path: '/community',
      icon: Users,
      label: 'Community'
    },
    {
      path: '/me',
      icon: User,
      label: 'Me'
    }
  ];

  const isActive = (path: string) => {
    if (path === '/explore') return location.pathname === '/explore';
    if (path === '/me') return location.pathname === '/me' || location.pathname.startsWith('/settings');
    if (path === '/next' && location.pathname.startsWith('/next-steps')) {
      return true;
    }
    if (path === '/community' && location.pathname.startsWith('/connections')) {
      return true;
    }
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  return (
    <nav 
      className="md:hidden fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-lg border-t border-neutral-200/60 z-50 safe-bottom shadow-2xl"
      role="navigation"
      aria-label="Main navigation"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <div className="flex items-center justify-around h-20 px-1">
        {navItems.map((item) => (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            className={`flex flex-col items-center justify-center w-full h-full min-w-[70px] min-h-[68px] focus-ring rounded-2xl transition-all duration-300 group active:scale-95 touch-manipulation ${
              isActive(item.path)
                ? 'text-white bg-gradient-to-r from-primary-500 to-secondary-500 shadow-lg transform -translate-y-1'
                : 'text-neutral-500 hover:text-primary-600 hover:bg-primary-50 active:bg-primary-100'
            }`}
            aria-label={item.label}
            aria-current={isActive(item.path) ? 'page' : undefined}
          >
            <item.icon 
              className={`h-6 w-6 transition-all duration-300 ${
                isActive(item.path) ? 'text-white scale-110' : 'text-neutral-500 group-hover:text-primary-600 group-hover:scale-105'
              }`} 
              aria-hidden="true"
            />
            <span className={`text-xs mt-1 font-medium transition-colors leading-tight ${
              isActive(item.path) ? 'text-white' : 'text-neutral-500 group-hover:text-primary-600'
            }`}>{item.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default BottomNavBar;